
const useStyles = () => ({
    container:{
        background: "#F6F7F9"
    },
    top_text:{
        fontFamily: "Heebo",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "21px",
        display: "flex",
        alignItems: "center",
        textAlign: "right",
        color: "#000000",
        opacity: "0.7",
        paddingTop:"50px"
    },
    child_info_text:{
        fontFamily: "Heebo",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "23px",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        color: "#000000"
    },

    input_text:{
        fontFamily: "Open Sans Hebrew",
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: "16px",
        lineHeight: "23px",
        display: "flex",
        alignItems: "center",
        textAlign: "right",
        color: "#111617",
        opacity: 0.7
    },

    purple_text: {
        fontFamily: "Open Sans Hebrew",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: "23px",
        display: "flex",
        alignItems: "center",
        textAlign: "right",
        color: "#a84cff",
        opacity: 0.7
    }
});

export default useStyles